// @ts-nocheck
import React, { useRef, forwardRef } from 'react';
import { TextField, InputAdornment } from '@mui/material';

const CustomTextField = forwardRef(({
  label,
  placeholder = "",
  value,
  onChange,
  variant = 'outlined',
  startAdornment = null,
  sx = {},
  required = false,
  readOnly = false,
  disabled = false,
  ...props
}, ref) => {


  return (
    <TextField
      label={label}
      placeholder={placeholder}
      variant={variant}
      fullWidth
      size="small"
      required={required}
      value={value}
      onChange={onChange}
      disabled={disabled || readOnly}
      InputProps={{
        startAdornment: startAdornment && (
          <InputAdornment position="start">
            {startAdornment}
          </InputAdornment>
        ),
        readOnly: readOnly, // Set readOnly here
      }}
      sx={{
        ...sx, bgcolor: readOnly && disabled ? "#ededed" : "initial", borderRadius: 1, '&.MuiOutlinedInput-input': {
          fontSize: 11
        }
      }}
      inputRef={ref}
      {...props}
    />
  );
});

export default CustomTextField;
